import React from 'react';

/**
 * Кружок із номером кроку.
 *
 * До цього кожна сторінка малювала його сама, і на сайті набралося п'ять
 * різних: 28, 32, 36, 40 і 44 пікселі, обведені, залиті, на бірюзовій
 * підкладці, з тінню й без. Поруч вони не стоять, але, переходячи зі
 * сторінки на сторінку, око це помічає. Тепер три розміри й три варіанти.
 *
 * size:
 * - 'sm' (32px) — кроки в рядку чи в щільному переліку;
 * - 'md' (40px, за замовчуванням) — вертикальна шкала поруч із h3;
 * - 'lg' (44px) — поруч із h2, коли номер позначає цілий етап.
 *
 * variant:
 * - 'outline' (за замовчуванням) — звичайний крок; тінь лише тут: білий
 *   кружок на білому без неї губиться;
 * - 'filled' — крок, на якому все сходиться (старт роботи), або етап;
 * - 'soft' — кружок усередині клікабельної плитки: там обведення злилося
 *   б із рамкою самої плитки.
 *
 * Номер без нуля попереду: «01» читається як код чи артикул, а «1» — як
 * крок. Якщо в даних номер рядком «01», нуль відкидаємо тут.
 *
 * `className` — для станів наведення плитки (group-hover:…) і відступів.
 */
const SIZES = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10',
  lg: 'w-11 h-11'
};

const VARIANTS = {
  outline: 'bg-white border border-teal-300 text-teal-700 shadow-sm',
  filled: 'bg-teal-700 text-white',
  soft: 'bg-teal-50 border border-teal-200 text-teal-700'
};

const StepNumber = ({ n, size = 'md', variant = 'outline', className = '' }) => {
  const label = typeof n === 'string' ? n.replace(/^0+(?=\d)/, '') : n;
  return (
    <span
      className={`relative flex-shrink-0 ${SIZES[size] || SIZES.md} rounded-full font-bold flex items-center justify-center ${
        VARIANTS[variant] || VARIANTS.outline
      } ${className}`}
    >
      {label}
    </span>
  );
};

export default StepNumber;
